// extracted by mini-css-extract-plugin
export default {"form":"change-password_form__Qhc4h","row":"change-password_row__euuEO"};